import StatueSection from './statue-section';
import PopupCard from './popup-card';

const settings = {
    classNames: {
        container: 'manifestation-statues',
    },

    // Delay between hiding one card and showing another,
    // in milliseconds
    popupCardCrossnavDelay: 125,
};

/**
 * The statue screen seen on "manifestation" pages
 */
export default class ManifestationStatues extends StatueSection {
    constructor(container) {
        // Call base class
        super(container);

        // Setup popup cards for any hotspots that were located in the component
        this.popupCards = {};
        this.hotspots.forEach((hotspot) => {
            if (!hotspot.card) {
                return;
            }

            const popupCard = new PopupCard(
                hotspot.card,
                {
                    onClose: (keyboardEvent) => {
                        hotspot.deselect();

                        // If we closed due to a keyboard event, set focus
                        // on the hotspot
                        if (keyboardEvent) {
                            hotspot.button.focus();
                        }
                    },
                });

            this.popupCards[hotspot.cardName] = popupCard;
        });
    }

    static init() {
        // Find elements with the expected class name
        const elements = document
            .getElementsByClassName(settings.classNames.container);

        for (let i=0; i<elements.length; i++) {
            new ManifestationStatues(elements[i]);
        }
    }

    /**
     * Handles body click events to deselect hotspots
     * @param {event} event
     */
    handleBodyClickEvent(event) {
        // Stop if the click occurred inside a popup card
        if (event.target.closest(`.${PopupCard.classNames.container}`)) {
            return;
        }

        // Call base class
        super.handleBodyClickEvent(event);
    }

    /**
     * Called when a hotspot is selected
     * @param {HotSpot} hotspot
     * @param {boolean} keyboardEvent
     */
    hotspotSelected(
        hotspot,
        keyboardEvent,
    ) {
        const hotspotWasSelected = this.currentHotspot !== null;

        // Call base class
        super.hotspotSelected(hotspot, keyboardEvent);

        // Show the associated popup card
        const popupCard = this.popupCards[hotspot.cardName];
        if (!popupCard) {
            return;
        }

        const callback = function() {
            // Clear the timeout variable
            this.newCardTimeout = null;

            // Show popup card
            popupCard.show(keyboardEvent);
        }.bind(this);

        if (hotspotWasSelected) {
            // A hotspot was just deselected - wait a moment
            // before showing the next popup card
            if (this.newCardTimeout) {
                clearTimeout(this.newCardTimeout);
            }

            this.newCardTimeout = setTimeout(
                callback,
                settings.popupCardCrossnavDelay,
            );
        } else {
            // A hotspot wasn't just deselected - show this card
            // right away
            callback();
        }
    }

    /**
     * Called when a hotspot is deselected
     * @param {HotSpot} hotspot
     * @param {boolean} keyboardEvent
     */
    hotspotDeselected(
        hotspot,
        keyboardEvent,
    ) {
        // Call base class
        super.hotspotDeselected(hotspot, keyboardEvent);

        // Hide the associated popup card
        const popupCard = this.popupCards[hotspot.cardName];
        if (popupCard) {
            popupCard.hide();
        }
    }
}
